import Image from '@components/Image'
import { ElementHTML } from '@helpers/helper.rendering'
import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData, TeamMember as TeamMemberType } from 'types'
import { Modal } from 'react-bootstrap'

const Team = (props: RealEstateDataPageComponentData) => {
  const { global_data } = props
  const {
    title,
    subtitle,
    paragraphs,
    team,
    titleElement,
    subtitleElement,
    paragraphElement,
    image_gatsby,
    opacityValue,
    spanText,
    columns,
    groupName,
  } = props

  const icons: string = global_data.pageConfig.design.icons

  const iconsStyle = icons === 'Solid' || icons === 'Light' ? `-${icons.toLowerCase()}` : ''

  const TeamMember = require(`../../teamMember/1`)?.default

  // Loader effect
  const [load, setLoad] = useState(true)
  useEffect(() => {
    setLoad(() => false)
  }, [])

  const [bioStatus, setBioStatus] = useState<{ id: number; status: boolean }[]>([])

  const RenderModals = () => {
    return (
      <div>
        {team?.map((member, index) => (
          <Modal
            className={'modal-bio-team-1'}
            show={bioStatus?.find((status: { id: number }) => status?.id === index)?.status}
            style={{ background: 'transparent', padding: 0, zIndex: 99999 }}
            centered
            key={index}
            tabindex={99}
          >
            <div
              className="close-button cursor-pointer"
              style={{ height: '1rem', width: '1rem' }}
              onClick={() =>
                setBioStatus([
                  ...bioStatus.filter((status: { id: number }) => status.id !== index),
                  { id: index, status: false },
                ])
              }
            ></div>
            <img
              src={member.imageBio}
              alt="Bio"
            />
          </Modal>
        ))}
      </div>
    )
  }

  return (
    <section className="team-section b p-y-config">
      <Image
        className="w-100 h-100 background-image-absolute no-border "
        objectFit="cover"
        alt="about-us-img"
        image={image_gatsby!!}
      />
      <div
        className="opacity"
        style={{
          opacity: opacityValue ? parseInt(opacityValue) / 100 : 0.8,
          backgroundColor: spanText ?? '#6b6b6b',
        }}
      ></div>
      <Container fluid>
        <Row>
          <Col lg={2}>
            <ElementHTML
              children={title || 'Equipo'}
              elementType={titleElement || 'p'}
              className="section-name"
            />
          </Col>
          {subtitle && (
            <Col lg={10}>
              <ElementHTML
                children={subtitle || ''}
                elementType={subtitleElement || 'h2'}
                className="sub-section mt-lg-0 mt-3 mb-4 mb-lg-0"
              />
            </Col>
          )}
          {paragraphs?.length! > 0 && (
            <Col
              className="my-lg-5 my-2 mb-5"
              lg={{ span: 10, offset: 2 }}
            >
              {paragraphs?.map((paragraph, index) => (
                <ElementHTML
                  key={index}
                  className="paragraph-section"
                  children={paragraph}
                  elementType={paragraphElement || 'p'}
                />
              ))}
            </Col>
          )}
          <Col
            lg={{ span: 10, offset: 2 }}
            className="team-wrapper"
          >
            <Row>
              {team?.map(
                (member: TeamMemberType, index: number) => (
                  <Col
                    lg={columns === '4' ? 3 : 4}
                    md={12}
                    xs={12}
                    sm={12}
                    className="card-personal a mb-4"
                    key={index}
                  >
                    {member.image_gatsby && (
                      <Image
                        image={member.image_gatsby!!}
                        alt="Portada"
                        className="w-100 h-100 profile-image mb-3"
                        objectFit="cover"
                      />
                    )}
                    {!member.image_gatsby && <div className="top"></div>}
                    <h4>
                      {member.name} {member.surname}
                    </h4>
                    <p>{member.position}</p>
                    <p>{member.matricula}</p>
                    {member.imageBio && <div className="top mt-3 mb-4"></div>}
                    {member.imageBio && (
                      <div
                        className="btn btn-white border"
                        onClick={() =>
                          setBioStatus([
                            ...bioStatus.filter((status: { id: number }) => status.id !== index),
                            { id: index, status: true },
                          ])
                        }
                      >
                        {groupName || 'Ver bio'}
                      </div>
                    )}
                  </Col>
                ),
                // <TeamMember
                //   key={index}
                //   member={member}
                //   iconsStyle={iconsStyle}
                // />
              )}
            </Row>
          </Col>
        </Row>
      </Container>
      <RenderModals />
    </section>
  )
}

export default Team
